import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import useRecoleccionesMes from "../../hooks/punto_generacion/useRecoleccionesMes";
import { getChartOption } from "../../utils/punto_generacion/chart_recolecciones_mes";
import "../../styles/graficas.css";

const RecoleccionesMes = ({ year, token, idPuntoGeneracion }) => {
  const chartRef = useRef(null);
  const data = useRecoleccionesMes(year, token, idPuntoGeneracion);

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0 && chartRef.current) {
      let myChart = echarts.getInstanceByDom(chartRef.current);
      if (myChart) {
        myChart.dispose();
      }
      myChart = echarts.init(chartRef.current);

      const updateChart = () => {
        const options = getChartOption(data);
        myChart.setOption(options);
        myChart.resize();
      };

      updateChart();

      window.addEventListener("resize", updateChart);
      return () => {
        window.removeEventListener("resize", updateChart);
        myChart.dispose();
      };
    }
  }, [data]);

  if (!Array.isArray(data) || data.length === 0) {
    return <p>Cargando datos...</p>;
  }

  return <div className="grafica" id="RecolectadosAlMes" ref={chartRef}></div>;
};

export default RecoleccionesMes;